// <GENERATED-CODE>
// Generated from Java using 'npm run generate:ts'

const FILTER_TYPE_VALUES = [
  'PREFIX',
  'SUBSTRING',
  'PATTERN'
] as const;

/** @see net/disy/cadenza/api/result/table/FilterType.java */
export type FilterType = typeof FILTER_TYPE_VALUES[number];

export const FilterType = {
  values: FILTER_TYPE_VALUES as readonly FilterType[]
} as const;

// </GENERATED-CODE>
